import React from "react";
import { StatusStepperContainer } from "../styled";

const StatusStepper = ({ currentStatus }) => {
  const deliveryStatusOptions = [
    { label: "배송시작", value: "SHIPPING_START" },
    { label: "배송중", value: "SHIPPING" },
    { label: "배송완료", value: "DELIVERED" },
  ];

  return (
    <StatusStepperContainer className={`status ${currentStatus}`}>
      {deliveryStatusOptions.map((status) => (
        <li key={status.value}>
          <div></div>
          <span>{status.label}</span>
        </li>
      ))}
    </StatusStepperContainer>
  );
};

export default StatusStepper;
